import request from '@/utils/request'
const baseURL = '/API/User/Link'
export const GetLink = function (data) {
    return request({
        url: '/API/User/Link/GetLink',
        method: 'GET',
        params: data
    })
}